import React from 'react';
import { SUB_TYPE_PARK } from '../../consts/sub-type.consts';
import { RouteFormatter } from '../../routes';
import SpotDetails from '../../components/seo-listings/spot-details';
import SnifHr from '../../components/snif-hr';
import './spot-type-card.scss';

const getSpotTypeList = (city) => {
    const spotTypeList = [];

    SUB_TYPE_PARK.forEach((s) => {
        const cityType = city.subpages?.find((sub) => sub.pageType == s.type);
        if (cityType) {
            spotTypeList.push({ ...s, url: cityType.url, spots: cityType.spots, name: cityType.name });
        }
    });

    return spotTypeList;
};

const RenderSpotTypeCard = ({ city, getSpotPhotosPaged }) => {
    let spotTypeList = getSpotTypeList(city);

    if (!spotTypeList.length) {
        return '';
    }

    return (
        <div className="sniff-other-types">
            <div className="l-container">
                <h2 className="snif-m1 snif-l1-pc snif-semibold text-dark mb-3 mb-md-4">What types of private dog parks are available?</h2>
                <p className="snif-p text-dark mb-5">Sniffspot has different types of private dog parks to allow any dog to find their ideal spot!</p>
                <div>
                    {spotTypeList?.map((sub, idx) => {
                        const baseTitle = `${sub?.title?.toLowerCase()} in ${city?.name}`;
                        const myTitle = baseTitle.charAt(0).toUpperCase() + baseTitle.slice(1);
                        const subTitle = `See all ${baseTitle}`;

                        if (!sub.spots.length) {
                            return '';
                        }

                        return (
                            <div key={idx}>
                                <h3 className="snif-m2 snif-l2-pc snif-semibold">{myTitle}</h3>
                                <div className="type-cards">
                                    {sub.spots.map((spot, idx) => {
                                        const first = idx === 0;
                                        return <SpotDetails key={idx} target="_blank" {...{ spot, first, getSpotPhotosPaged }} />;
                                    })}
                                </div>
                                <p className="snif-p snif-m2-pc snif-semibold text-primary text-md-end">
                                    <a
                                        href={RouteFormatter.listings({ first: sub.url })}
                                        target="_blank"
                                        rel={`${sub.totalSpots < 3 ? 'nofollow ' : ''}noopener noreferrer`}
                                    >
                                        {subTitle}
                                    </a>
                                </p>
                                <div className="my-4 my-md-5">{spotTypeList.length - 1 != idx && <SnifHr w100 />}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default RenderSpotTypeCard;
